import { useState, useEffect } from "react";
import dayjs from 'dayjs';

import { Form, Spin, Card, Tabs, Row, Col, Input } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { useNavigate } from "react-router-dom";

import { apiCand } from "../../../services/apiCand";
import "../style.css";

import CadInfoBotoes from "../Componentes/CadInfoBotoes";
import CertificadorasPerfil from "../Componentes/CertificadorasPerfil"
import CertificadorasTipoCertificado from "../Componentes/CertificadorasTipoCertificado"
import CertificadorasDocumentos from "../Componentes/CertificadorasDocumentos"
import { hasDocMandatory } from "../Utils/Misc"

import { resetColor } from "../../../styles/cnpjColor";
import { errorMessage, mostrarInfo, mostrarInfoDetail, successMessage } from "../../../utils/messages";
import { ITipocertificado, IDocumentoCertificadora, ICertificadoraConsulta, ICertificadora, IAreaCertificadora } from "../Componentes/InterfaceCertificadoras";
import { isStateWithoutDataValid, onlyNumbers } from "../../../utils/utilsFunctions";
import { IErroApi } from "../../../Interfaces/Interfaces";
import { useLocation } from "react-router";
import { maskCnpj } from "../../../utils/maskFunctions";


const Cadastrar = (props: any) => {

  const { state } = useLocation();

  const [isDirty, setIsDirty] = useState(false);

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [certificadoraRetPosCadastro, setCertificadoraRetPosCadastro] = useState<ICertificadoraConsulta>();

  const [tipoCertificados, setTipoCertificados] = useState<ITipocertificado[]>([]);
  const [certificadoraDocumentos, setCertificadoraDocumentos] = useState<IDocumentoCertificadora[]>([]);

  const [areasCertificadoras, setAreasCertificadoras] = useState<IAreaCertificadora[]>([]);

  const [manter, setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")


  useEffect(() => {
    if (isStateWithoutDataValid(state)) {

      form.setFieldsValue({
        "cnpj": maskCnpj(state.cnpj),
        "razaoSocial": state.razaoSocial,
      });
    }
  }, []);


  useEffect(() => {
    if (certificadoraRetPosCadastro) pushToManter(certificadoraRetPosCadastro);
  }, [certificadoraRetPosCadastro]);

  function pushToManter(cert: any) {  // ABRE A TELA DE DETALHES DA CERTIFICADORA
    const certificadoraPerfil = form.getFieldsValue();

    let tpSelecao = {
      cnpj: onlyNumbers(certificadoraPerfil?.cnpj),
      razaoSocial: certificadoraPerfil?.razaoSocial.toUpperCase(),
      manter: 2,
      data: cert
    }
    navigate("/certificadoras/manter", { replace: true, state: tpSelecao });
  }

  function verificaTipoCertificados() {  // DEV EXISTIR PELO MENOS UM CERTIFICADO ATIVO
    let endOk = false;
    if (tipoCertificados.length > 0) {
      tipoCertificados.forEach((e: ITipocertificado) => {
        if (e.statusReg === 1) endOk = true;
      });
    }
    return endOk;
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [touched, setTouched] = useState(true);

  const [dtCancelamentoIncluida, setDtCancelamentoIncluida] = useState(false);

  function verificaDtCancelamento() {
    let ret = false;
    if (dtCancelamentoIncluida) {
      // Verifica se existe um novo documento do tipo nota técnica
      certificadoraDocumentos.forEach((e: IDocumentoCertificadora) => {
        if (e.statusReg === 1 && e.nmDocumento?.toUpperCase() === "NOTA TÉCNICA" && e.idCertificadoraDocumento === -1) {
          ret = true;
        }
      });
    } else {
      ret = true;
    }
    return ret;
  }

  function validaDtReconhecimentoCertificadora(dtReconhecimentoCertificadora: string, tipoCertificados: ITipocertificado[]) {  // NÃO PODE EXISTIR DATA DE RECONHECIMENTO DE CERTIFICADOS MAIOR DO QUE A DATA DE RECONHECIMENTO DA CERTIFICADORA
    let dtOk = true;
    if (tipoCertificados.length > 0) {
      tipoCertificados.forEach((e: ITipocertificado) => {
        if (e.dtReconhecimento && e.dtReconhecimento !== ""){
          // console.log(dayjs(e.dtReconhecimento).format("YYYY-MM-DD"));
          if (dayjs(e.dtReconhecimento).format("YYYY-MM-DD") < dayjs(dtReconhecimentoCertificadora).format("YYYY-MM-DD")){
            dtOk = false;
          }
        }
      });
    }
    return dtOk;
  }

  const validarCertificadora = () => {
    if (!verificaDtCancelamento()) {
      mostrarInfo("Campos inconsistentes", "A inclusão da data de cancelamento de certificadora exige também a inclusão de uma nova nota técnica");
    } else if (!validaDtReconhecimentoCertificadora(form?.getFieldValue("dtReconhecimento"), tipoCertificados)) {
      mostrarInfo("Erro na data de reconhecimento da certificadora", "A data de reconhecimento da certificadora não pode ser maior do que uma data de reconhecimento de certificado");
    } else if (hasDocMandatory(certificadoraDocumentos) !== 1) {
      mostrarInfo("Erro em documentos", "Um e apenas um documento dentre 'ESTATUTO' e 'CONTRATO SOCIAL' deve ser incluído");
    } else if (!verificaTipoCertificados()) {
      mostrarInfo("Erro em certificados", "Deve existir pelo menos um tipo certificado ativo");
    } else {
      form
        .validateFields([
          "nuProcesso",
          "dtReconhecimento",
          "dtCancelamento",
        ])
        .then(() => {
          sendForm();
        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido");
        });
    }
  };

  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const certificadoraPerfil = form.getFieldsValue();
    const json: ICertificadora = {
      idCertificadora: -1,
      nuProcesso: onlyNumbers(certificadoraPerfil?.nuProcesso) || "",
      cnpj: state.cnpj,
      dtReconhecimento: form?.getFieldValue("dtReconhecimento") ? dayjs(form?.getFieldValue("dtReconhecimento")).format("YYYY-MM-DD") : "",
      dtCancelamento: form?.getFieldValue("dtCancelamento") ? dayjs(form?.getFieldValue("dtCancelamento")).format("YYYY-MM-DD") : "",
      statusReg: 1,
      certificadoraDocumentos: certificadoraDocumentos.map((e: IDocumentoCertificadora) => {
        return {
          ...e
        };
      }),
      certificadoraAreas: areasCertificadoras.map((e: IAreaCertificadora) => {
        return ({
          ...e,
        })
      }),
      certificadoraTiposCertificados: tipoCertificados.map((e: ITipocertificado) => {
        return {
          ...e
        };
      }),
    };
    // console.log("Subindo json");
    // console.log(json);


    await apiCand.post(`/certificadoras`, json).then((response) => {
      setLoading(false);
      // console.log("retorno")
      // console.log(response)

      resetForm();
      successMessage(
        `Certificadora ${certificadoraPerfil?.razaoSocial.toUpperCase()} cadastrada com Sucesso`
      );

      setCertificadoraRetPosCadastro(response.data);
      // setManter(1)
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });


  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    setCertificadoraDocumentos([]);
    form.setFieldsValue({
      nuProcesso: "",
      dtReconhecimento: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "Tem certeza de que deseja sair da página? Podem existir dados não salvos.";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isDirty]);

  return (
    <>
      {/* <Prompt
        when={form.getFieldValue("nuProcesso") && form.getFieldValue("nuProcesso") !== ""}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title="Cadastrar Certificadoras"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card title="Informações Básicas" variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            onFinish={validarCertificadora}
            scrollToFirstError
          >

            <Row>
              <Col xs={24} sm={8}>
                <Form.Item hidden={true} name="cnpj"></Form.Item>
                <Form.Item hidden={true} name="razaoSocial"></Form.Item>

                <Form.Item label="CNPJ" name="cnpjDisabled">
                  <Input defaultValue={maskCnpj(state.cnpj)} disabled={true} onChange={() => setIsDirty(true)} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={16}>
                <Form.Item label="Razão Social" name="razaoSocialDisabled">
                  <Input defaultValue={state.razaoSocial} disabled={true} />
                </Form.Item>
              </Col>
            </Row>

            <Card title={"Perfil da Certificadora"}>
              <>
                <CertificadorasPerfil
                  setAreasCertificadoras={setAreasCertificadoras}
                  areasCertificadoras={areasCertificadoras}
                  form={form}
                  tipoCertificados={tipoCertificados}
                  setDtCancelamentoIncluida={setDtCancelamentoIncluida}
                  manter={manter}
                  loaded={false}
                />
              </>
            </Card>

            <Tabs>
              <Tabs.TabPane tab="Certificados" key="item-1">
                <>
                  <CertificadorasTipoCertificado
                    tipoCertificados={tipoCertificados}
                    setTipoCertificados={setTipoCertificados}
                    form={form}
                    manter={manter}
                    areasCertificadoras={areasCertificadoras}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Documentação" key="item-2">
                <>
                  <CertificadorasDocumentos
                    documentos={certificadoraDocumentos}
                    setDocumentos={setCertificadoraDocumentos}
                    form={form}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>
            </Tabs>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              // desabilitaBtnEditar={true}
              // desabilitaBotoes={desabilitaBotoes}
              desabilitar={touched}
              setDesabilitar={setTouched}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
              checkedValues={areasCertificadoras}
            />

          </Form>
        </Card>
      </Spin>

    </>
  );
};

export default Cadastrar;